import { Group } from "@mantine/core"

import type {
  OperationGraphNodeDto,
  SourceContextGraphNodeDto,
} from "~/gen/api/types"
import { HorizontalDivider } from "~/pages/Brand/Products/Details/TraceabilityGraph/Divider.tsx"
import { SupplierCard } from "~/pages/Brand/Products/Details/TraceabilityGraph/SupplierCard.tsx"

import type { ForkOriginCue } from "./traceability-graph.view-model"

type Props = {
  node: OperationGraphNodeDto | SourceContextGraphNodeDto
  hideFirstDivider?: boolean
  parentReferences: string[]
  originCue?: ForkOriginCue
}

export const TraceabilityTreeBranch = ({
  node,
  hideFirstDivider = false,
  parentReferences,
  originCue,
}: Props) => {
  const operation =
    node.operation !== "not-entered-yet" ? node.operation : undefined

  return (
    <Group key={node.id} gap={0} align="flex-start" wrap="nowrap">
      {!hideFirstDivider && <HorizontalDivider />}
      <SupplierCard
        activityName={node.activityName}
        itemReference={node.reference}
        parentReferences={parentReferences}
        operation={operation}
        originCue={originCue}
      />
    </Group>
  )
}
